// Matches RasterCoverage::MAP_CELL_DEGREES
const MAP_CELL_DEGREES = 0.5;

export const MAX_MAP_CELLS = 36;

export function cellsInBounds([west, south, east, north]) {
  const cells = [];
  const clampLat = (lat) => Math.max(-85, Math.min(85, lat));

  for (
    let x = Math.floor(west / MAP_CELL_DEGREES);
    x <= Math.floor(east / MAP_CELL_DEGREES);
    x++
  ) {
    for (
      let y = Math.floor(clampLat(south) / MAP_CELL_DEGREES);
      y <= Math.floor(clampLat(north) / MAP_CELL_DEGREES);
      y++
    ) {
      cells.push({ x, y, key: `${x}/${y}` });
    }
  }

  return cells;
}

export function fetchCell({ x, y }) {
  return fetch(`/raster_coverages/map_cells/${x}/${y}`).then((response) => {
    if (!response.ok) {
      throw new Error(`Map cell ${x}/${y} failed (${response.status})`);
    }
    return response.json();
  });
}
